define('views/modules/setting/business/blocks/brand/brand-edit-content',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // events
    'services/user',
    // views
    'src/views/form-view',
    'views/parts/menu/menu-save-action',
    'views/modules/setting/business/blocks/brand/brand-edit-form',
    'views/modules/setting/business/blocks/brand/url-edit-form',
    'views/parts/alert/alert-list',
    // templates
    'text!templates/modules/setting/business/blocks/brand/brand-edit-content.html',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // events
    User,
    // views
    VForm,
    VMenuSaveAction,
    VBrandEditForm,
    VUrlEditForm,
    VAlertList,
    // templates
    TBrandEditContent
) {

    var VBrandEditContent = VForm.extend({
        template: TBrandEditContent,

        regions: {
            root: "#brand-edit-content",
            menu: ".menu-actions",
            brand: ".brand-edit-form",
            url: ".url-edit-form",
            alert: ".alert-list",
        },

        initialize: function(options) {

            this.group = options.group;

            this.view = {
                menu: new VMenuSaveAction({
                    context: this,
                    onClick: this.onActionClick,
                    onSave: this.onSaveButton,
                    saveText: "Save",
                    radio: false,
                    tooltip: { container: this.regions.root, }
                }),
                brand: new VBrandEditForm({ model: this.model }),
                url: new VUrlEditForm({ model: this.model }),
                alert: new VAlertList({
                    collection: new Backbone.Collection([])
                })
            };

            this.listenTo(this.model, { 'change': this.onModelChange });
        },

        render: function() {
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext()));

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.setPristine();

            this.assign(view.menu, zone.$menu)
                .assign(view.brand, zone.$brand)
                .assign(view.url, zone.$url)
                .assign(view.alert, zone.$alert);

            return this;
        },

        onActionClick: function(e) {
            e.preventDefault();
        },

        onModelChange: function() {
            this.view.menu.toggleSaveButton(!this.isDirty());
        },

        onSaveButton: function() {
            this.submit();
        },

        onSuccess: function() {
            User.fetch({ force: true }); // refreshing user profile to apply new logo/color
        },

        onError: function(response) {
            if (response && response.responseJSON) {
                var errorCode = response.responseJSON.code;

                if (errorCode) {
                    this.view.alert.reset();
                    this.view.alert.addError("api-messages:" + errorCode.replace(/_/g, '-'));
                    this.$el.parent().animate({
                        scrollTop: 0
                    }, 'fast');
                }
            }
        }

    });

    return VBrandEditContent;
});

